import type { GeneralLink } from '../linkQueries';
import { LinkFieldType } from '../linkQueries';

function normalizedSlug(slug: string | undefined): string {
  return (slug ?? '').replace(/^\//, '');
}

/** `data-analytics-click-behaviour` for a CMS button general link: `{linkType}-{slug}`. */
export function analyticsClickBehaviourForGeneralLink(link: GeneralLink): string {
  const slug =
    link.linkType === LinkFieldType.INTERNAL
      ? normalizedSlug(link.reference?.slug)
      : '';
  return `${link.linkType}-${slug}`;
}
